module.exports = __webpack_public_path__ + "img/gstc-icon.2e2c0f90.png";